import { useRef, useState } from "react";
import { UploadCloud } from "lucide-react";

import { cn } from "../ui/utils";

export function UploadDropzone({
  accept,
  onFiles,
  disabled = false,
  icon: Icon = UploadCloud,
  title = "Click or drag a file",
  description,
  className,
  children,
}) {
  const inputRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);

  const handleFiles = (files) => {
    if (!files?.length || !onFiles) {
      return;
    }
    onFiles(Array.from(files));
  };

  const handleDrop = (event) => {
    event.preventDefault();
    if (disabled) return;
    setIsDragging(false);
    handleFiles(event.dataTransfer.files);
  };

  const handleBrowse = (event) => {
    if (disabled) return;
    handleFiles(event.target.files);
    event.target.value = "";
  };

  const openFileDialog = () => {
    if (disabled) return;
    inputRef.current?.click();
  };

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={openFileDialog}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          openFileDialog();
        }
      }}
      onDrop={handleDrop}
      onDragOver={(event) => {
        event.preventDefault();
        if (!disabled) {
          setIsDragging(true);
        }
      }}
      onDragLeave={() => setIsDragging(false)}
      className={cn(
        "flex flex-col items-center justify-center rounded-2xl border border-dashed border-border/60 bg-muted/20 px-6 py-10 text-center transition-all",
        isDragging && "border-primary bg-primary/10",
        disabled && "cursor-not-allowed opacity-60",
        !disabled && "cursor-pointer hover:border-primary/50 hover:bg-muted/30",
        className
      )}
    >
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        onChange={handleBrowse}
        multiple={false}
        hidden
      />
      {children ? (
        children
      ) : (
        <>
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 text-primary">
            <Icon className="h-8 w-8" />
          </div>
          <h3 className="mt-4 font-heading text-lg font-semibold text-foreground">
            {title}
          </h3>
          {description && (
            <p className="mt-2 text-sm text-muted-foreground">{description}</p>
          )}
        </>
      )}
    </div>
  );
}

